import type { FC } from "react";

import SkeletonCheckbox from "@/components/global/ControllerInput/BaseUI/Checkbox/SkeletonCheckbox";
import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";
import SkeletonTabComponent from "@/components/global/TabComponent/SkeletonTabComponent";
import { cn } from "@/utils/common/styleHelper/utils";

const SkeletonFlightSearchComponent: FC = () => {
  const dynamicWidthHeight = [
    { width: "md:w-[568px]", height: "xl:h-[66px]" },
    { width: "md:w-[392px]", height: "" },
    { width: "md:w-[160px]", height: "" },
  ];

  return (
    <div className="flex size-full flex-col gap-4 rounded-2xl bg-white p-4 shadow-sPlus md:p-6 md:pt-4 md:shadow-search">
      <div className="flex w-full justify-between">
        <SkeletonTabComponent length={2} />
        <SkeletonCheckbox className="hidden items-center md:flex" />
      </div>
      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col gap-4 md:flex-row">
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton key={index} className="h-16 w-full" />
          ))}
        </div>
        <div className="flex w-full flex-col gap-4 md:flex-row">
          {dynamicWidthHeight.map(({ width, height }, index) => (
            <Skeleton
              key={index}
              className={cn("h-16 w-full", width, height)}
            />
          ))}
        </div>
        <div className="flex h-[2.625rem] w-full items-center gap-2 md:hidden">
          <Skeleton className="size-5 flex-none rounded" />
          <div className="flex h-6 w-2/5 items-center">
            <Skeleton className="h-4 w-full" />
          </div>
        </div>
        <Skeleton className="h-12 w-full md:hidden" />
      </div>
    </div>
  );
};

export default SkeletonFlightSearchComponent;
